module.exports = __webpack_public_path__ + "static/media/scan-icon.5992456b.svg";